import FloatingPaneV2 from './FloatingPaneV2';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import useSuggestions from '../../hooks/useSuggestions';
import getFloatingPaneXOffset from './suggestionsFloatingPane/getFloatingPaneXOffset';

const SuggestionsFloatingPane = ({ id, alignWith, suggestions, onSuggestionChange }) => {
  const [input, setInput] = useState(null);
  const { availableSuggestions, handleComplete } = useSuggestions({ input, types: suggestions, onChange: onSuggestionChange });

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setInput(document.querySelector(`.${id}`));
    });
    return () => clearTimeout(timeoutId);
  }, [id]);

  const offset = useMemo(() => getFloatingPaneXOffset(input), [input]);

  const handleSuggestionClick = useCallback(
    (line) => {
      handleComplete(line);
    },
    [handleComplete]
  );

  const suggestionItems = useMemo(
    () =>
      availableSuggestions.map((line, i) => (
        <div key={i} className={`suggestion-line ${line?.selected ? 'selected' : ''}`} onMouseDown={(e) => e.preventDefault()} onClick={() => handleSuggestionClick(line)}>
          <div className={'left'}>
            <span className={'label-start'}>{line?.labelStart}</span>
            <span className={'label-end'}>{line?.labelEnd}</span>
            <span className={'type'}>{line.type}</span>{' '}
          </div>
          <div className={'right'}>{line.hint}</div>
        </div>
      )),
    [availableSuggestions, handleSuggestionClick]
  );

  if (availableSuggestions?.length < 1) {
    return null;
  }

  return (
    <FloatingPaneV2 className={'comp-suggestions-floating-pane'} active={true} matchTriggerWidth={true} alignWith={alignWith || `.${id}`} crossAxisOffset={offset}>
      {suggestionItems}
    </FloatingPaneV2>
  );
};

export default SuggestionsFloatingPane;
